import { render, staticRenderFns } from "./obmenpodat.vue?vue&type=template&id=1a00fc9a&scoped=true&"
import script from "./obmenpodat.vue?vue&type=script&lang=js&"
export * from "./obmenpodat.vue?vue&type=script&lang=js&"
import style0 from "./obmenpodat.vue?vue&type=style&index=0&id=1a00fc9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a00fc9a",
  null
  
)

export default component.exports